exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".menu__menu___2GVVI {\n  margin-right: 15px; }\n  .menu__menu___2GVVI ul {\n    list-style-type: none;\n    display: flex; }\n    .menu__menu___2GVVI ul li {\n      margin-left: 50px;\n      text-transform: uppercase;\n      color: #A1A4A3;\n      font-size: 1.2em;\n      cursor: pointer; }\n", ""]);

// exports
exports.locals = {
	"menu": "menu__menu___2GVVI"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules=true&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/sass-loader?includePaths[]=./src/styles!./src/containers/Menu/menu.scss
// module id = 893
// module chunks = 0